import { Img } from "./components/logo.component";

export const RA_CONFIG:{logo:Img} = {
  logo: {
    width: 30,
    height: 30,
    title: "Athena",
    imgUrl: {
      url:'../../assets/images/generali_logo.svg'
    }      
  }
};
